module.exports = __webpack_public_path__ + "assets/img/A5-4.8fe33de3.jpg";